import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import {PlanTypes} from '../../_components/PlanTypes/PlanTypes'
import {PricingPlans} from '../../_components/PricingPlans/PricingPlans'

import {Box, Button, Section} from '@primer/react-brand/esm'

import styles from './PricingSection.module.css'

import type {PricingSectionContent} from '../../content'

type Props = {
  contentfulContent: PricingSectionContent
}

export function PricingSection({contentfulContent}: Props) {
  const sectionId = contentfulContent.section.fields.htmlId
  const sectionIntro = contentfulContent.sectionIntro
  const planTypes = contentfulContent.planTypes
  const planItems = contentfulContent.planItems
  const pricingOptions = contentfulContent.pricingOptions
  const pricingFooter = contentfulContent.pricingFooter

  return (
    <Section id={sectionId}>
      {sectionIntro ? <ContentfulSectionIntro component={sectionIntro} className={styles.sectionIntro} /> : null}
      {planTypes ? <PlanTypes contentfulContent={planTypes} items={planItems} /> : null}
      {pricingOptions ? <PricingPlans contentfulContent={pricingOptions} variant="gridline" /> : null}

      {pricingFooter ? (
        <Box
          style={{textAlign: 'center'}}
          paddingBlockEnd={{
            narrow: 32,
            regular: 'none',
          }}
        >
          <Button as="a" href={pricingFooter.fields.link?.fields.href}>
            {pricingFooter.fields.link?.fields.text}
          </Button>
        </Box>
      ) : null}
    </Section>
  )
}
